import chttp from '@/libs/base/coupon_http';
import apis from '@/libs/base/apis';

const config = {
  state: {
    appletPicConfig: [],
    rankAttach: [],
  },
  mutations: {
    SAVE_APPLET_CONFIG(state, appletPicConfig) {
      state.appletPicConfig = appletPicConfig || [];
    },
    SAVE_RANK_ATTACH(state, rankAttach) {
      state.rankAttach = rankAttach || [];
    },
  },
  actions: {
    async getRankAttach({ commit }) {
      const res = await chttp.get(`${apis.getDataCommonApi}?key=vadd_cms_rank_attach`);
      commit('SAVE_RANK_ATTACH', res.data.srcList);
    },
  },
};

export default config;
